module.exports = __webpack_public_path__ + "static/media/item_6_24_comp.8e17ba6f.png";